import React, {Component} from 'react';
import moment from 'moment';
import _ from 'lodash';
import 'index.css';
import './PreviewFilm.scss';
import ReactMarkdown from 'react-markdown';
import VideoPlayer from 'components/VideoPlayer';
import Paiement from 'components/Paiement/Paiement';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Rating from '@material-ui/lab/Rating';
import Box from '@material-ui/core/Box';
import Conf from 'utils/Conf';
import SizedeImage from 'components/SizedImage';
import CartoucheSeance from 'components/CartoucheSeance';
import {withTranslation} from 'react-i18next';

// Teaser studio

class PreviewFilm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paiementOpen: false,
      seanceSelected: null,
    };
    this.handleSelectCinema = this.handleSelectCinema.bind(this);
    this.handleResetSelectedCinema = this.handleResetSelectedCinema.bind(this);
    this.handlePaiementOpen = this.handlePaiementOpen.bind(this);
    this.handlePaiementClose = this.handlePaiementClose.bind(this);
  }

  handlePaiementOpen(seance) {
    const {appState, ed} = this.props;
    if (appState.user.email) {
      this.setState({
        seanceSelected: seance,
        paiementOpen: true,
      });
    } else {
      ed.trigger('loginRegisterOpen');
    }
  }

  handlePaiementClose(c) {
    this.setState({paiementOpen: false});
  }

  handleSelectCinema(c) {
    const {onSizeChange} = this.props;
    this.setState({selectedCinema: c}, onSizeChange);
  }

  handleResetSelectedCinema(c) {
    const {onSizeChange} = this.props;
    this.setState({selectedCinema: null}, onSizeChange);
  }

  renderThirdColumn() {
    const {hidePartner, modele, film, t, appState} = this.props;
    const {selectedCinema} = this.state;
    if (hidePartner) {
      return null;
    }
    const seances = _.filter(modele.seances, {film_id: film.film_id});
    const cinemas = _.filter(modele.cinemas, c => seances.some(s => s.cinema_id === c.cinema_id));

    if (selectedCinema) {
      return (
        <Grid item xs={12} md={12} className="relative">
          <Button
            className="seance-btn"
            color="primary"
            size="small"
            variant="contained"
            onClick={this.handleResetSelectedCinema}
          >
            <ArrowBack />
          </Button>
          <div className="spacer" />
          <Typography variant="h4" component="h2" noWrap>
            {selectedCinema.cinema_name} <small>/ {selectedCinema.city_name}</small>
          </Typography>
          <Typography variant="subtitle1" component="h3" noWrap>
            {t('choisissez-votre-seance')}
          </Typography>
          <div className="spacer" />
          <Grid container spacing={3} className="preview">
            {_.filter(seances, {cinema_id: selectedCinema.cinema_id}).map(s => (
              <Grid item xs={12} md={6} lg={4} key={s.seance_id}>
                <CartoucheSeance {...this.props} seance={s} onPay={() => this.handlePaiementOpen(s)} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      );
    }

    return (
      <Grid item xs={12}>
        {cinemas.length > 0 && (
          <Typography variant={appState.screenSize === 'xs' ? 'h6' : 'h4'} noWrap>
            {t('choisissez-votre-cinema')}
          </Typography>
        )}
        <Grid container spacing={2} className="preview">
          {cinemas.map(c => (
            <Grid item xs={12} sm={6} md={3} lg={2} key={c.cinema_id}>
              <div
                className={`preview-cinema${appState.user.geolocOk && !c.local ? ' no-local' : ''}`}
                onClick={() => c.local && this.handleSelectCinema(c)}
              >
                <div className="cartouche-texte">
                  <Typography variant="h5" component="h2" noWrap>
                    <small className="semi">{c.city_name}</small>
                  </Typography>
                  <Typography variant="h5" component="h2" noWrap>
                    {c.cinema_name || '(sans titre)'}
                  </Typography>
                </div>
                <DialogActions>
                  <Button color="primary" disize="small" variant="contained" disabled={!c.local}>
                    {t('voir-les-seances')}
                  </Button>
                </DialogActions>
              </div>
            </Grid>
          ))}
        </Grid>
      </Grid>
    );
  }

  render() {
    const {film, t, appState, onClose, hidePartner, renderSessions} = this.props;

    const {paiementOpen, seanceSelected} = this.state;

    return (
      <Grid
        container
        spacing={appState.screenSize === 'xs' ? 1 : appState.screenSize === 'sm' ? 2 : 3}
        className="preview"
      >
        <div className="preview-film-close" onClick={onClose} />
        <div className="spacer" />
        <div className="spacer" />
        <Grid item xs={12} md={6}>
          <VideoPlayer video={film.teaser_id} autoplay />
          {['lg', 'md'].indexOf(appState.screenSize) !== -1 && (
            <Grid container spacing={3}>
              <Grid item xs={12} align="right">
                <div className="spacer" />
                <Typography variant="h6" className="infos-prod">
                  {t('realisation')}
                </Typography>
                <Typography variant="body1" className="infos-prod-value">
                  {film.infos_realisateur}
                </Typography>
                <Typography variant="h6" className="infos-prod">
                  {t('production')}
                </Typography>
                <Typography variant="body1" className="infos-prod-value">
                  {film.infos_producteur}
                </Typography>
                <Typography variant="h6" className="infos-prod">
                  {t('distribution')}
                </Typography>
                <Typography variant="body1" className="infos-prod-value">
                  {film.distributeur_name}
                </Typography>
                {film.infos_casting && (
                  <Typography variant="h6" className="infos-prod">
                    {t('casting')}
                  </Typography>
                )}
                {film.infos_casting && (
                  <Typography variant="body1" className="infos-prod-value">
                    {film.infos_casting}
                  </Typography>
                )}
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant={['lg', 'md'].indexOf(appState.screenSize) === 1 ? 'h4' : 'h5'}>
            {film.film_name || '(sans titre)'}
          </Typography>

          <Box alignItems="center" display="flex">
            <Box>
              <Typography variant="h6">
                {film.infos_annee_prod && moment(film.infos_annee_prod).format('YYYY')}
              </Typography>
            </Box>
            <Box>
              &nbsp;
              <Rating name="half-rating-read" value={parseFloat(film.infos_note)} precision={0.1} readOnly />
            </Box>
          </Box>
          <Grid container spacing={3} className="preview">
            <Grid item xs={12} sm={8} md={12} lg={12} xl={8}>
              <Typography variant="body1" component="div" className="preview-synopsis">
                <ReactMarkdown>{film.infos_synopsis}</ReactMarkdown>
              </Typography>
              <div className="spacer" />
              {film.infos_presse.map((p, i) => [
                <div className="quote" key={`${i}quote`}>
                  &laquo;&nbsp;{p.quote}&nbsp;&raquo;
                </div>,
                <div className="media" key={`from${i}`}>
                  {p.from}
                </div>,
                <div className="spacer" key={`${i}spacer`} />,
              ])}
              <Grid container spacing={3} className="preview">
                {film.infos_recompenses.map((r, i) => {
                  let logo = r.logo;
                  // if (r.logo) {
                    // let basename = r.logo.split(/[\\/]/).pop();
                    // logo = r.logo.replace(basename, `min/${basename}`);
                  // }
                  return (
                    <Grid item xs={6} md={6} key={i}>
                      <Grid container spacing={3} className="preview">
                        {logo && (
                          <Grid item xs={6}>
                            <SizedeImage shadow src={Conf.assetsRoot + logo} />
                          </Grid>
                        )}
                        <Grid item xs={logo ? 6 : 12}>
                          <div className="recompense">{r.prix}</div>
                          <div className="festival">{r.festival}</div>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
                {hidePartner && renderSessions && renderSessions(film.film_id)}
              </Grid>
            </Grid>
            {['lg', 'md'].indexOf(appState.screenSize) === -1 && (
              <Grid item xs={12} sm={4}>
                <Typography variant="h6" className="infos-prod">
                  {t('realisation')}
                </Typography>
                <Typography variant="body1" className="infos-prod-value">
                  {film.infos_realisateur}
                </Typography>
                <Typography variant="h6" className="infos-prod">
                  {t('production')}
                </Typography>
                <Typography variant="body1" className="infos-prod-value">
                  {film.infos_producteur}
                </Typography>
                <Typography variant="h6" className="infos-prod">
                  {t('distribution')}
                </Typography>
                <Typography variant="body1" className="infos-prod-value">
                  {film.distributeur_name}
                </Typography>
                {film.infos_casting && (
                  <Typography variant="h6" className="infos-prod">
                    {t('casting')}
                  </Typography>
                )}
                {film.infos_casting && (
                  <Typography variant="body1" className="infos-prod-value">
                    {film.infos_casting}
                  </Typography>
                )}
              </Grid>
            )}
          </Grid>
        </Grid>
        {this.renderThirdColumn()}
        <Paiement open={paiementOpen} onClose={this.handlePaiementClose} seance={seanceSelected} />
      </Grid>
    );
  }
}

export default withTranslation()(PreviewFilm);
